import React from 'react';
import { NavDropdown } from "react-bootstrap";

import SaleReportLink from "../sale_report/SaleReportLink";

import ApiKeyContext from "../../../../contexts/ApiKeyContext";
import { useAuth } from "../../../../auth/useAuth";
import { ProductUtil } from "../../../../util/Product.util";

export default function ProductDetailMenu({ item, catalog, close }) {
	const API_KEY_CONTEXT = React.useContext(ApiKeyContext);
	const { organizationMember } = useAuth();

	// TODO: Pass organization handle
	// TODO: Pass profile handle
	const options = {
		fieldset: catalog.detail_fieldset?.handle,
		catalog: catalog.id
	}
	const openPdf = () => window.open(pdf_url.toString());

	const organization_member_data = JSON.parse(localStorage.getItem('organization_member:data')) || organizationMember;
	const pdf_url = ProductUtil.Make_Pdf_Url({
		product: item,
		profile_token: organization_member_data?.profile?.public_token,
		organization_id: organization_member_data?.organization?.id,
	});
	pdf_url?.searchParams.set("options", JSON.stringify(options));

	//only customers invited to the catalog should be able to see sales report
	//if a user's api-key is 1, then that means they're not a customer to the catalog.
	const isCustomer = API_KEY_CONTEXT.apiKey !== 1;
	return (
		<NavDropdown className="menu" title="">
			{
				catalog.options.sale_report?.report
				&& item
				&& isCustomer
				&& (
					<NavDropdown.Item>
						<SaleReportLink form={catalog.options.sale_report.form} item={item} />
					</NavDropdown.Item>
				)
			}
			{pdf_url && <NavDropdown.Item onClick={openPdf}><span>Open PDF</span></NavDropdown.Item>}
			<NavDropdown.Item onClick={close}><span>Close</span></NavDropdown.Item>
		</NavDropdown>
	);
}